import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

// Models.
import { AuthInfo, AuthReq } from '../models/authObjects';

// Tikis.
import { Api } from '../common/constants/api';
import { ServerResponse } from '../models/RES/serverResponse';
import { NewEmploymentHistory } from '../models/REQ/newEmploymentHistory';
import { NewPersonalReference } from '../models/REQ/newPersonalReference';

@Injectable({
    providedIn: 'root'
})
export class PersonalReferencesByPersonService {
  constructor(
    private _http: HttpClient
  ) {}

  url: string = Api.PersonalReferenceByPersons;
  jsonHeaders = { headers: { 'Content-Type': 'application/json' } }

  public GetAll(): Observable<ServerResponse> {
    return this._http.get<ServerResponse>(`${this.url}/GetAll`);
  }

  public GetReferencesByPerson(dataId: number): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/GetReferencesByPerson`, dataId, this.jsonHeaders);
  }

  public Create(data: NewPersonalReference): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/Create`, data);
  }

  public Edit(data: NewPersonalReference): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/Edit`, data);
  }

  public Disable(data: number): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/Disable`, data);
  }
}